import JSZip from 'jszip';

export const getUniqueProperties = features => {
  const propNames = {};
  features.forEach(feature => {
    if (feature.properties) {
      Object.keys(feature.properties).forEach(propName => {
        propNames[propName] = true;
      });
    }
  });
  return Object.keys(propNames);
};

export const validateFeatures = ({
  features,
  abortController,
  maxVertexCount = 1500,
}) => {
  const worker = new Worker(
    new URL('./worker/validator-worker.js', import.meta.url),
    {
      type: 'module',
    },
  );

  const workerPromise = new Promise((resolve, reject) => {
    worker.onmessage = ({data: {type, ...data}}) => {
      resolve(data);
    };

    worker.onerror = () => {
      reject();
    };
  });

  if (abortController) {
    abortController.signal.addEventListener('abort', () => {
      worker.terminate();
    });
  }
  worker.postMessage({features, maxVertexCount});
  return workerPromise;
};

export const getFeatureLabel = (
  feature,
  idx,
  labelProperty,
  includeFileName,
) => {
  const prefix = includeFileName ? feature.properties.pl_filename : '';
  return labelProperty && feature.properties[labelProperty]
    ? `${prefix} ${feature.properties[labelProperty]}`
    : `${prefix} feature #${idx + 1}`;
};

export const getFileExtension = path => path.toLowerCase().split('.').pop();

// ToDo: import from importer package once updated
export function extractZip(zipfile) {
  return new Promise((resolve, reject) => {
    zipfile
      .arrayBuffer()
      .then(bytes => JSZip.loadAsync(bytes))
      .then(zip => {
        const files = [];
        zip.forEach((path, file) => {
          const fakeFile = {
            name: path,
            text: () => {
              return file.async('text');
            },
            arrayBuffer: () => {
              return file.async('uint8array');
            },
          };
          files.push(fakeFile);
        });
        resolve(files);
      })
      .catch(err => reject(err));
  });
}

export const transformFeature = (
  feature,
  propMap = {title: '', description: ''},
  defaultTitle = '',
) => {
  const properties = {};
  Object.keys(propMap).forEach(propName => {
    if (feature.properties) {
      const value = feature.properties[propMap[propName]];
      if (value) {
        properties[propName] = value;
      }
    }
  });

  if (!properties.title) {
    properties.title = defaultTitle;
  }

  let id = undefined;
  if (properties.id) {
    id = properties.id;
    delete properties.id;
  }

  return {
    ...feature,
    properties,
    id,
  };
};
